import React from "react";
import { Box, Button, Modal } from "@mui/material";
import styled from "styled-components";

type ModalLargeProps = {
  open: boolean;
  onClose?: (event: {}, reason: "backdropClick" | "escapeKeyDown") => void;
  title?: string;
};

export default function ModalLarge({
  open,
  onClose,
  title,
  children,
}: React.PropsWithChildren<ModalLargeProps>) {
  const buttonCloseClickHandle = React.useCallback(() => {
    if (onClose) {
      onClose({}, "backdropClick");
    }
  }, [onClose]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "2rem",
          left: "2rem",
          width: "calc(100% - 4rem)",
          height: "calc(100% - 4rem)",
          bgcolor: "background.paper",
          boxShadow: 24,
          overflow: "scroll",
          padding: "0.5rem",
        }}
      >
        <h3 id="modal-title">{title}</h3>
        <p id="modal-description">{children}</p>
        <DivButtonUpperRight>
          <Button onClick={buttonCloseClickHandle}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
            >
              <path d="M6 6L18 18M6 18L18 6" />
            </svg>
          </Button>
        </DivButtonUpperRight>
        {/* <Button onClick={buttonCloseClickHandle}>Close</Button> */}
      </Box>
    </Modal>
  );
}

const DivButtonUpperRight = styled.div`
  & button {
    position: absolute;
    display: block;
    top: 0.5rem;
    right: 0.5rem;
    padding: 0;
    min-width: auto;
    color: #aaa;
  }
`;
